import React, { Component } from "react";
import Myoption from "./option";

class Select extends Component {
  state = {
    open: false,
    def: ""
  };
  handelClick = () =>
    this.setState({
      open: !this.state.open
    });
  handelChoose = def => {
    this.setState({
      def
    });
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.state === prevState) return;
    this.props.onChange({
      name: this.props.name,
      value: this.state.def
    })
  }

  render() {
    const options = this.props.options.map((v, i, a) => {
      return (
        <Myoption
          value={v}
          name={v}
          key={v}
          handelChoose={this.handelChoose}
          isLast={i === a.length - 1}
        />
      );
    });
    let classname = this.state.open ? 'my-select shadow-1 open' : 'my-select shadow-1';
    return (
      <div className="row selects">
        <div className={classname} name={this.props.name} onClick={this.handelClick} >
          <div className="default-option ">
            {this.state.def || this.props.default}
          </div>
          <div className="select-icon"><span > V</span></div>
          {this.state.open ? options : <div />}
        </div>
      </div>
    );
  }
}
export default Select;
